'use client';
import { PageLayout } from '@xtnd/web/shared/layout';
import { MatterArDetailProvider } from '../components/common';
import EmailQueueTable from '../components/email/EmailQueueTable';

export default function EmailQueuePage() {
  return (
    <PageLayout
      title="Email Queue"
      description="Manage and monitor email queue for collections communications."
    >
      <MatterArDetailProvider>
        <EmailQueueTable />
      </MatterArDetailProvider>
    </PageLayout>
  );
}
